import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { yyyymmddGenerator } from "../Analytics/AnalyticsUtils/yyyymmddGenerator";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useAppStore } from "../../../appStore";
import { enUS, enGB } from "date-fns/locale";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { useNavigate } from "react-router-dom";

export const EndDateDropDownFrontel = () => {
  const {
    userFiltersFrontel,
    setUserFiltersFrontel,
    setTimeFiltersDisabledFrontel,
  } = useClipsStore();

  const navigate = useNavigate();

  const [endTimeAnchorEl, setEndTimeAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const endTimeOpen = Boolean(endTimeAnchorEl);
  const handleEndTimeClick = (event: React.MouseEvent<HTMLElement>) => {
    setEndTimeAnchorEl(event.currentTarget);
  };
  const handleEndTimeClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setEndTimeAnchorEl(null);
  };

  const { dateMMDDYYYY, setDateMMDDYYYY } = useAppStore();

  const selectedLocale = dateMMDDYYYY ? enUS : enGB;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={selectedLocale}
    >
      <DatePicker
        label={
          userFiltersFrontel.end_date ? (
            <div className="flex">
              <>End Date</>
              <div>
                <IconButton
                  aria-label="more"
                  id="long-button-frontel-end"
                  aria-controls={
                    endTimeOpen ? "long-menu-frontel-end" : undefined
                  }
                  aria-expanded={endTimeOpen ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleEndTimeClick}
                  sx={{
                    marginLeft: "5px",
                    padding: 0,
                    color: "#000000",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu-frontel-end"
                  MenuListProps={{
                    "aria-labelledby": "long-button-frontel-end",
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  anchorEl={endTimeAnchorEl}
                  open={endTimeOpen}
                  onClose={handleEndTimeClose}
                  slotProps={{
                    paper: {
                      style: {
                        maxHeight: 48 * 4.5,
                        width: "20ch",
                      },
                    },
                  }}
                >
                  <MenuItem
                    key="mm-dd-yyyy-end-frontel"
                    onClick={(event) => {
                      setDateMMDDYYYY(true);
                      handleEndTimeClose(event);
                    }}
                  >
                    MM/DD/YYYY
                  </MenuItem>
                  <MenuItem
                    key="dd-mm-yyyy-end-frontel"
                    onClick={(event) => {
                      setDateMMDDYYYY(false);
                      handleEndTimeClose(event);
                    }}
                  >
                    DD/MM/YYYY
                  </MenuItem>
                </Menu>
              </div>
            </div>
          ) : (
            <>End Date</>
          )
        }
        value={userFiltersFrontel.end_date}
        onChange={(newValue) => {
          if (newValue !== null) {
            setUserFiltersFrontel((previousState: any) => ({
              ...previousState,
              end_date: newValue,
            }));
          }
          if (newValue === null) {
            setUserFiltersFrontel((previousState: any) => ({
              ...previousState,
              end_date: null,
            }));
          }
          if (
            yyyymmddGenerator(newValue) !==
            yyyymmddGenerator(userFiltersFrontel.start_date)
          ) {
            setTimeFiltersDisabledFrontel(true);
            setUserFiltersFrontel((previousState: any) => ({
              ...previousState,
              start_time: null,
              end_time: null,
            }));
          }
          if (
            yyyymmddGenerator(newValue) ===
            yyyymmddGenerator(userFiltersFrontel.start_date)
          ) {
            setTimeFiltersDisabledFrontel(false);
          }
          // TODO: Add getDownloadURLFrontel call when API function is ready
          // getDownloadURLFrontel(navigate);
        }}
        renderInput={(params) => <TextField sx={{ width: 150 }} {...params} />}
      />
    </LocalizationProvider>
  );
};
